const MODAL_ELEMENT = document.getElementById('atb-modal');

try {
// Attach bootstrap modal.hide() to the header button
MODAL_ELEMENT.querySelector('.modal-header button').addEventListener('click', () => {
    const modal = bootstrap.Modal.getOrCreateInstance(MODAL_ELEMENT);
    modal.hide();
}); }
catch (error) {
    console.error('Error attaching event listener to modal header button:', error);
}

let lastCallBack = null

/**
 * Function for showing a modal, wrapped around Bootstrap's Modal API
 * @param {*} modalTitle - the header/title of the modal
 * @param {string} modalBody - string or HTML
 * @param {object} buttonProps object 
 */
export function showModal(
    modalTitle, 
    bodyHTML, 
    { 
        buttonCallback = null,
        buttonOpts = {},
        buttonText = 'Continue',
        doHideOnClick = true
    } = {}
) {
    const modal = bootstrap.Modal.getOrCreateInstance(MODAL_ELEMENT);
    MODAL_ELEMENT.querySelector('.modal-title').innerHTML = modalTitle;
    MODAL_ELEMENT.querySelector('.modal-body').innerHTML = bodyHTML;
    
    const continueModalBtn = MODAL_ELEMENT.querySelector('#atb-modal-continue-button');
    continueModalBtn.textContent = buttonText;

    // Remove the last callback incase this modal was used for different purposes
    if (lastCallBack) {
        continueModalBtn.removeEventListener('click', lastCallBack);
        lastCallBack = null;
    }

    // If a callback was passed, attach it

    let handler = null;
    if (buttonCallback) {
        handler = () => {
            buttonCallback();
            if (doHideOnClick) {
                modal.hide();
            }
        }
    } else {
        handler = () => {
            if (doHideOnClick) {
                modal.hide();
            }
        }
    }
    
    continueModalBtn.addEventListener('click', handler, buttonOpts);
    lastCallBack = handler;

    modal.show();
}